import { createSlice } from '@reduxjs/toolkit'

import { IHoldDetail } from './web3.type'

const initialState = {
  holdings: [] as IHoldDetail[],
  holder: [] as IHoldDetail[],
}

const Web3Slice = createSlice({
  name: 'web3',
  initialState,
  reducers: {
    setHoldings: (state, action) => {
      state.holdings = action.payload
    },
    setHolder: (state, action) => {
      state.holder = action.payload
    },
  },
  extraReducers: () => {},
})

export const Web3Actions = Web3Slice.actions
const Web3Reducer = Web3Slice.reducer
export default Web3Reducer
